import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"


import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { ref, computed, onMounted } from 'vue'
import {
  regionSettingList,
  deleteRegionSetting
} from '@/api/yuntuSales/regionSetting'
import { listByParamCodes } from '@/api/common'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { Modal as AModal } from 'ant-design-vue'
import { getDeptInfo } from '@/api/common'
const __default__ = { name: 'DcCosLbuRegionSetting' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const editModalRef = ref<{ toggle: (row?: any) => void }>()

const tableRef = ref()
const queryForm = ref({})
const deptInfo4List = ref([])

const fetchDeptInfo = async () => {
  const res = await getDeptInfo({ appId: 'cos_lbu', rootId: '3853844' })
  deptInfo4List.value = res.data?.deptInfo[0]?.children
  deptInfo4List.value.forEach((item: any) => {
    if (item.children && item.children.length) {
      item.children.forEach((o: any) => {
        if (o.children) delete o.children
      })
    }
  })
}
// 获取列表
const fetch = async (params: any, callBack: (res: any) => void) => {
  try {
    const res = await regionSettingList({ ...params })
    callBack(res)
  } catch (error) {
    console.log('fetcherror: ', error)
  }
}

const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const columns = computed(() => [
  { title: '区域', dataIndex: 'deptName' },
  { title: '查看人', dataIndex: 'deptManager' },
  { title: '更新人', dataIndex: 'updateBy' },
  { title: '更新时间', dataIndex: 'updateTime' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: any) => {
  editModalRef.value?.toggle(_row)
}

const deleteRow = (row: any) => {
  Modal.delete({
    name: row.deptName,
    onOk() {
      deleteRegionSetting({id: row.id}).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
        success()
      })
    }
  })
}

onMounted(() => {
  fetchDeptInfo()
})


return (_ctx: any,_cache: any) => {
  const _component_CosCascader = _resolveComponent("CosCascader")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm.value,
            "onUpdate:search": _cache[3] || (_cache[3] = ($event: any) => ((queryForm).value = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosRegionSetting"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "deptIdList",
                    label: "区域"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosCascader, {
                        placeholder: "请选择",
                        type: "search",
                        options: deptInfo4List.value,
                        fieldNames: { label: 'label', value: 'id', children: 'children' },
                        appId: "cos_lbu",
                        multiple: "",
                        ids: queryForm.value.deptIdList,
                        "onUpdate:ids": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.value.deptIdList) = $event))
                      }, null, 8, ["options", "ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "deptManagerId",
                    label: "查看人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: queryForm.value.deptManagerId,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.value.deptManagerId) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'deptManager')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(record.deptManagerInfo.map((emp) => `${emp.employeeName}(${emp.employeeNo})`).join(',')), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'updateBy')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(`${record.updateByName}(${record.updateBy})`), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 2 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (addEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_region_setting_edit_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (deleteRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_region_setting_delete_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (addEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_region_setting_add_btn']
              ])
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(editModal, {
            ref_key: "editModalRef",
            ref: editModalRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})